/**
 * Pan slot component.  @deprecated Pan is deprecated, please use `</[Chart].Pan>` instead.
 *
 */
export const Pan = () => null;
/* oxlint-disable-next-line typescript/no-deprecated */
Pan['displayName'] = 'Pan';
